import {
  IconArmchair,
  IconBath,
  IconBed,
  IconBuildingCommunity,
  IconChefHat,
  IconDoor,
  IconStairs,
  IconToolsKitchen2,
  IconTree,
} from '@tabler/icons-react';

import { RoomType } from 'src/types/cartography.types';

export type RoomCategoryKey =
  | 'living'
  | 'kitchen'
  | 'bedroom'
  | 'sanitary'
  | 'circulation'
  | 'outdoor'
  | 'annex'
  | 'common'
  | 'other';

export interface RoomCategory {
  key: RoomCategoryKey;
  icon: typeof IconDoor;
  types: RoomType[];
}

/**
 * Les 8 familles proposées à l'étape 2 du drawer, plus « Autre ».
 * Reprises telles quelles de la MR !384 pour ne pas réinventer un vocabulaire
 * déjà validé côté produit.
 */
export const ROOM_CATEGORIES: RoomCategory[] = [
  {
    key: 'living',
    icon: IconArmchair,
    types: [
      RoomType.LIVING_ROOM,
      RoomType.DINING_ROOM,
      RoomType.OFFICE,
      RoomType.LIBRARY,
      RoomType.PLAYROOM,
      RoomType.GYM,
      RoomType.HOME_CINEMA,
      RoomType.VERANDA,
      RoomType.RECEPTION_ROOM,
    ],
  },
  {
    key: 'kitchen',
    icon: IconChefHat,
    types: [RoomType.KITCHEN, RoomType.PANTRY, RoomType.LAUNDRY, RoomType.LARDER],
  },
  {
    key: 'bedroom',
    icon: IconBed,
    types: [
      RoomType.BEDROOM,
      RoomType.MASTER_BEDROOM,
      RoomType.DORMITORY,
      RoomType.STUDIO_APARTMENT,
      RoomType.DRESSING_ROOM,
      RoomType.STORAGE_ROOM,
    ],
  },
  {
    key: 'sanitary',
    icon: IconBath,
    types: [RoomType.BATHROOM, RoomType.SHOWER_ROOM, RoomType.POWDER_ROOM, RoomType.TOILET],
  },
  {
    key: 'circulation',
    icon: IconStairs,
    types: [
      RoomType.ENTRANCE,
      RoomType.HALLWAY,
      RoomType.LANDING,
      RoomType.STAIRWELL,
      RoomType.MEZZANINE,
      RoomType.ATTIC,
      RoomType.BASEMENT,
      RoomType.CELLAR,
      RoomType.WINE_CELLAR,
      RoomType.BOILER_ROOM,
    ],
  },
  {
    key: 'outdoor',
    icon: IconTree,
    types: [
      RoomType.OUTDOOR,
      RoomType.GARDEN,
      RoomType.TERRACE,
      RoomType.BALCONY,
      RoomType.LOGGIA,
      RoomType.COURTYARD,
      RoomType.POOL,
      RoomType.POOL_HOUSE,
    ],
  },
  {
    key: 'annex',
    icon: IconToolsKitchen2,
    types: [
      RoomType.GARAGE,
      RoomType.CARPORT,
      RoomType.PARKING_SPACE,
      RoomType.WORKSHOP,
      RoomType.SHED,
      RoomType.OUTBUILDING,
      RoomType.BARN,
      RoomType.STABLE,
    ],
  },
  {
    key: 'common',
    icon: IconBuildingCommunity,
    types: [RoomType.COMMON_AREA, RoomType.LOBBY, RoomType.BIKE_ROOM, RoomType.BIN_ROOM],
  },
  {
    key: 'other',
    icon: IconDoor,
    types: [RoomType.OTHER],
  },
];

/**
 * Les 8 types épinglés en tête du drawer : ceux qu'un gestionnaire saisit le plus souvent.
 * Les choisir saute directement à l'étape des détails.
 */
export const COMMON_ROOM_TYPES: RoomType[] = [
  RoomType.BEDROOM,
  RoomType.KITCHEN,
  RoomType.LIVING_ROOM,
  RoomType.DINING_ROOM,
  RoomType.BATHROOM,
  RoomType.SHOWER_ROOM,
  RoomType.TOILET,
  RoomType.ENTRANCE,
];

export const CATEGORY_BY_TYPE: Record<RoomType, RoomCategoryKey> = ROOM_CATEGORIES.reduce(
  (acc, category) => {
    for (const type of category.types) acc[type] = category.key;
    return acc;
  },
  {} as Record<RoomType, RoomCategoryKey>
);
